/**
 * スタイルシートの注入。CSS はバンドルに同梱され、外部 CSS ファイルの読み込みは不要（NFR-DIST-01）。
 * 同一 document に複数ビューワがあっても <style> は 1 枚を共有し、参照カウントで解放する。
 */
import styles from 'virtual:styles';
import { cls } from '../brand';

interface Injected {
  el: HTMLStyleElement;
  count: number;
}

const injected = new WeakMap<Document, Injected>();

/** スタイルを注入し、解放関数を返す（最後の解放で <style> を取り除く）。 */
export function acquireStyles(doc: Document): () => void {
  let entry = injected.get(doc);
  if (!entry) {
    const el = doc.createElement('style');
    el.className = cls('styles');
    el.textContent = styles;
    doc.head.appendChild(el);
    entry = { el, count: 0 };
    injected.set(doc, entry);
  }
  const current = entry;
  current.count += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    current.count -= 1;
    if (current.count === 0) {
      current.el.remove();
      injected.delete(doc);
    }
  };
}
